import React from 'react';

export default function AnimatedGradientText({ children, className = '', as: Tag = 'span' }) {
  return (
    <Tag
      className={`animated-gradient-text ${className}`}
      style={{
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        backgroundClip: 'text',
      }}
    >
      {children}
    </Tag>
  );
}
